window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initVariants();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.PortfolioSlider = (function () {

  /*var selectors = {
   addToCart: '[data-add-to-cart]',
   addToCartText: '[data-add-to-cart-text]',
   comparePrice: '[data-compare-price]',
   comparePriceText: '[data-compare-text]',
   originalSelectorId: '[data-product-select]',
   priceWrapper: '[data-price-wrapper]',
   productFeaturedImage: '[data-product-featured-image]',
   productJson: '[data-product-json]',
   productPrice: '[data-product-price]',
   productThumbs: '[data-product-single-thumbnail]',
   singleOptionSelector: '[data-single-option-selector]'
   };*/


  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function PortfolioSlider(container) {
    this.$container = $(container);

    this.settings = {};
    this.namespace = '.portfolio';

    var sectionId = this.$container.attr('data-section-id');

    var portfolioSelectors = {
      sliderContainer: $('.portfolio').attr('data-section-id', sectionId),
      sliderPrevArrow: $('.slick-prev').attr('data-section-id', sectionId),
      sliderNextArrow: $('.slick-next').attr('data-section-id', sectionId)
    };


    this.initSlider(portfolioSelectors);
  }

  PortfolioSlider.prototype = $.extend({}, PortfolioSlider.prototype, {

    initSlider: function (sliderContainer) {
      sliderContainer.sliderContainer.slick({
        dots: true,
        infinite: true,
        speed: 500,
        prevArrow: sliderContainer.sliderPrevArrow,
        nextArrow: sliderContainer.sliderNextArrow
      });

    },


    onBlockSelect: function (evt) {
      this.$container.off(this.namespace);

      var slideIndex = $('.slick-slide[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)').attr('data-slick-index');
      $('.portfolio').attr('data-section-id', evt.detail.sectionId).slick('slickGoTo', slideIndex)

    }

  });

  return PortfolioSlider;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.ProcessSlider = (function () {

  /*var selectors = {
   addToCart: '[data-add-to-cart]',
   addToCartText: '[data-add-to-cart-text]',
   comparePrice: '[data-compare-price]',
   comparePriceText: '[data-compare-text]',
   originalSelectorId: '[data-product-select]',
   priceWrapper: '[data-price-wrapper]',
   productFeaturedImage: '[data-product-featured-image]',
   productJson: '[data-product-json]',
   productPrice: '[data-product-price]',
   productThumbs: '[data-product-single-thumbnail]',
   singleOptionSelector: '[data-single-option-selector]'
   };*/


  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function ProcessSlider(container) {
    this.$container = $(container);
    this.settings = {};
    this.namespace = '.process';

    var sectionId = this.$container.attr('data-section-id');

    var portfolioSelectors = {
      sliderContainer: $('.process').attr('data-section-id', sectionId),
      sliderPrevArrow: $('.slick-prev').attr('data-section-id', sectionId),
      sliderNextArrow: $('.slick-next').attr('data-section-id', sectionId)
    };


    this.initSlider(portfolioSelectors);
  }

  ProcessSlider.prototype = $.extend({}, ProcessSlider.prototype, {

    initSlider: function (sliderContainer) {
      sliderContainer.sliderContainer.slick({
        dots: true,
        infinite: true,
        speed: 500,
        prevArrow: sliderContainer.sliderPrevArrow,
        nextArrow: sliderContainer.sliderNextArrow
      });

    },


    onBlockSelect: function (evt) {
      this.$container.off(this.namespace);

      var slideIndex = $('.slick-slide[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)').attr('data-slick-index');
      $('.process').attr('data-section-id', evt.detail.sectionId).slick('slickGoTo', slideIndex)

    }

  });

  return ProcessSlider;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Slider = (function () {

  /*var selectors = {
   addToCart: '[data-add-to-cart]',
   addToCartText: '[data-add-to-cart-text]',
   comparePrice: '[data-compare-price]',
   comparePriceText: '[data-compare-text]',
   originalSelectorId: '[data-product-select]',
   priceWrapper: '[data-price-wrapper]',
   productFeaturedImage: '[data-product-featured-image]',
   productJson: '[data-product-json]',
   productPrice: '[data-product-price]',
   productThumbs: '[data-product-single-thumbnail]',
   singleOptionSelector: '[data-single-option-selector]'
   };*/

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Slider(container) {
    this.$container = $(container);
    this.settings = {};
    this.namespace = '.slider';

    var sectionId = this.$container.attr('data-section-id');

    var portfolioSelectors = {
      sliderContainer: $('.slider[data-section-id="' + sectionId + '"]'),
      sliderAutoplay: $('.slider[data-section-id="' + sectionId + '"]').attr('data-autoplay'),
      sliderAutoplaySpeed: $('.slider[data-section-id="' + sectionId + '"]').attr('data-speed'),
      sliderFrames: $('.slider__frame[data-section-id="' + sectionId + '"]')
    };





    this.initSlider(portfolioSelectors);
  }

  Slider.prototype = $.extend({}, Slider.prototype, {

    initSlider: function (sliderContainer) {


      if (sliderContainer.sliderAutoplay == 'true') {
        sliderContainer.sliderContainer.slick({
          dots: true,
          infinite: true,
          speed: 500,
          prevArrow: false,
          nextArrow: false,
          autoplay: true,
          autoplaySpeed: sliderContainer.sliderAutoplaySpeed,
          pauseOnHover: false
        });
      } else {
        sliderContainer.sliderContainer.slick({
          dots: true,
          infinite: true,
          speed: 500,
          prevArrow: false,
          nextArrow: false
        });
      }

      $.each(sliderContainer.sliderFrames, function(i,v) {
        if (i > 0) {
          $(this).attr('style','display: none;')
        }
      });

      sliderContainer.sliderContainer.on('beforeChange', function(event, slick, currentSlide, nextSlide){

        setTimeout(function() {
          $(sliderContainer.sliderFrames[currentSlide]).removeClass('animated').attr('style','display: none;');
        }, 200);
        $(sliderContainer.sliderFrames[nextSlide]).addClass('animated').attr('style', '');
      });

    },



    onBlockSelect: function (evt) {
      this.$container.off(this.namespace);

      var slideIndex = $('.slick-slide[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)').attr('data-slick-index');
      $('.slider').attr('data-section-id', evt.detail.sectionId).slick('slickGoTo', slideIndex)

    }

  });

  return Slider;
})();



/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.TestimonialSlider = (function () {

  /*var selectors = {
   addToCart: '[data-add-to-cart]',
   addToCartText: '[data-add-to-cart-text]',
   comparePrice: '[data-compare-price]',
   comparePriceText: '[data-compare-text]',
   originalSelectorId: '[data-product-select]',
   priceWrapper: '[data-price-wrapper]',
   productFeaturedImage: '[data-product-featured-image]',
   productJson: '[data-product-json]',
   productPrice: '[data-product-price]',
   productThumbs: '[data-product-single-thumbnail]',
   singleOptionSelector: '[data-single-option-selector]'
   };*/

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function TestimonialSlider(container) {
    this.$container = $(container);
    this.settings = {};
    this.namespace = '.slider';

    var sectionId = this.$container.attr('data-section-id');

    var TestimonialSelectors = {
      sliderContainer: $('.slider[data-section-id="' + sectionId + '"]'),
      id: sectionId,
      sliderAutoplay: $('.slider[data-section-id="' + sectionId + '"]').attr('data-autoplay'),
      sliderAutoplaySpeed: $('.slider[data-section-id="' + sectionId + '"]').attr('data-speed')
    };


    this.initTestimonialSlider(TestimonialSelectors);

    TestimonialSelectors.sliderContainer.on('swipeMove', function (event, slick, swipeLeft, positionOffset, swipeLength) {
      /*if (positionOffset == 1) {
        $('.slide__overlay.slick-center > .overlay__item').css({
          'width': swipeLength,
          'right': 0,
          'left': 'auto',
          'max-width': '100%'
        });
      } else {
        $('.slide__overlay.slick-center > .overlay__item').css({
          'width': swipeLength,
          'left': 0,
          'right': 'auto',
          'max-width': '100%'
        });
      }*/

      /*$('.overlay__item[data-section-id="' + sectionId + '"').each(function() {
        $(this).css('display','none')
      });

      $('.testimonial__wrapper[data-section-id="' + sectionId + '"').addClass('testimonial__wrapper--active');
      console.log(positionOffset);
      // left*/
    });

    /*TestimonialSelectors.sliderContainer.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.slick-slide[data-slick-index="' + currentSlide + '"] > .overlay__item').attr('style','');
      console.log($('.slick-slide[data-slick-index="' + currentSlide + '"] > .overlay__item'));
      console.log(nextSlide)
      // left
    });*/
  }

  TestimonialSlider.prototype = $.extend({}, TestimonialSlider.prototype, {

    initTestimonialSlider: function (sliderContainer) {
      if (sliderContainer.sliderAutoplay == 'true') {
        sliderContainer.sliderContainer.slick({
          dots: false,
          slidesToShow: 3,
          centerMode: true,
          swipeToSlide: true,
          centerPadding: '0px',
          autoplay: true,
          autoplaySpeed: sliderContainer.sliderAutoplaySpeed,
          speed: 500,
          prevArrow: $('.slider__button.slider__prevArrow[data-section-id="' + sliderContainer.id + '"]'),
          infinite: true,
          nextArrow: $('.slider__button.slider__nextArrow[data-section-id="' + sliderContainer.id + '"]'),
          responsive: [{
            breakpoint: 800,
            settings: {
              slidesToShow: 1
            }
          }]
        });
      } else {
        sliderContainer.sliderContainer.slick({
          dots: false,
          slidesToShow: 3,
          centerMode: true,
          swipeToSlide: true,
          centerPadding: '0px',
          pauseOnHover: false,
          speed: 500,
          prevArrow: $('.slider__button.slider__prevArrow[data-section-id="' + sliderContainer.id + '"]'),
          infinite: true,
          nextArrow: $('.slider__button.slider__nextArrow[data-section-id="' + sliderContainer.id + '"]'),
          responsive: [{
            breakpoint: 700,
            settings: {
              slidesToShow: 1
            }
          }]
        });
      }
    },


    onBlockSelect: function (evt) {
      this.$container.off(this.namespace);

      var slideIndex = $('.slick-slide[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)').attr('data-slick-index');
      $('.slider').attr('data-section-id', evt.detail.sectionId).slick('slickGoTo', slideIndex);

    }

  });

  return TestimonialSlider;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Create = (function () {


    /**
     * Create section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Create(container) {
        this.$container = $(container);
        this.settings = {};
        this.namespace = '.create_navigation';

        /**
         * Collect section Variables required for cart input & information transfer
         * Required: section.id -> block.id -> block.theme -> block.input -> block.input.position -> block.input.position.letter
         *
         * */


        /*============================================================================
          #Variables
            - Constants
            - Window Items

        ==============================================================================*/

        const section_id = this.$container.attr('data-section-id');
        const input_container = $('#frame__input');
        const fixed_size_frame = $('#frame_to_image');
        const facebook_link = $('.social-sharing__link--facebook');
        const twitter_link = $('.social-sharing__link--twitter');
        const pinterest_link = $('.social-sharing__link--pinterest');
        const download_link = $('#final-artwork__sharing--download');

        let modal = {
            container: $('#create__modal'),
            content: $('#create__modal .modal__body'),
            checkbox_array: $('.modal__theme-input input'),
            active_image_array: $('.preload-image[data-selection-type="modal"]')
        };

        const create_navigation = {
            slider: $('.create__slider'),
            process_steps: $('.process__item'),

            step_1: $('.create__step-1'),
            reset_button_1: $('.create__step-1 button.button--reset'),
            next_button_1: $('.create__step-1 button.button--next'),

            step_2: $('.create__step-2'),
            prev_button_2: $('.create__step-2 button.button--prev'),
            next_button_2: $('.create__step-2 button.button--next'),

            step_3: $('.create__step-3'),
            prev_button_3: $('.create__step-3 button.button--prev'),
            next_button_3: $('.create__step-3 button.button--next'),

            step_5: $('.create__step-4'),
            prev_button_4: $('.create__step-4 button.button--prev'),
            next_button_4: $('.create__step-4 button.button--next')
        };

        const frame = {
            container: $('.frame'),
            image_array_1: $('.create__step-1 .frame__letter'),
            image_array_2: $('.create__step-3 .frame__letter'),
            image_array_3: $('.create__artwork-to-image .frame__letter'),
            image_array_4: $('.create__step-4 .frame__letter'),
            label: $('.frame__label'),
            background: {
                left: $('.frame__image.frame__image--left'),
                center: $('.frame__image.frame__image--center'),
                right: $('.frame__image.frame__image--right')
            }
        };

        const theme = {
            item_array: $('.theme__item'),
            frame_change: $('.theme-change__item')
        };

        const final_artwork = {
            container: $('#final-artwork'),
            word: $('#final-artwork__word'),
            format: $('#final-artwork__format'),
            size: $('#final-artwork__size'),
            frame: $('#final-artwork__frame'),
            price: $('#final-artwork__price'),
            giftwrap_input: $('#final-artwork__giftwrap'),
            gift_message_input: $('#final-artwork__message'),
            sharing_link: $('#final-artwork__link')

        };

        const cart_form = {
            form: $('#add-to-cart__form'),
            frame: $('#add-to-cart__frame'),
            properties: $('#add-to-cart__properties'),
            letter_0: $('#add-to-cart__letter-0'),
            letter_1: $('#add-to-cart__letter-1'),
            letter_2: $('#add-to-cart__letter-2'),
            letter_3: $('#add-to-cart__letter-3'),
            letter_4: $('#add-to-cart__letter-4'),
            letter_5: $('#add-to-cart__letter-5'),
            letter_6: $('#add-to-cart__letter-6'),
            letter_7: $('#add-to-cart__letter-7'),
            letter_8: $('#add-to-cart__letter-8')
        };


        window.url_values = {
            image_url: window.image_url || ''
        };
        let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            if (key) {
                url_values[decodeURIComponent(key)] = decodeURIComponent(value);
            }
        });

        window.onTimeout = [];

        let create_data = {
            input: [],
            input_array: [],
            previous_input_array: [],
            resize_length: window.create_section.default_frame_size,
            frame: window.create_section.frame,
            frame_variant_details: product_frames[3].variants[4],
            theme: window.create_section.theme,
            artwork_image_src: '',
            facebook_sharing_url: '',
            twitter_sharing_url: '',
            pinterest_sharing_url: '',
            modal: {
                theme_array: [window.create_section.theme],
                current_letter: '',
                position: 0,
                custom_image_array: []
            },
            frame_images: {},
            gift_wrap: false,
            gift_message: ''
        };

        $.each(window.product_frames, function (i, v) {
            let frame = window.product_frames[i];
            let handle = frame.handle;
            create_data.frame_images[handle] = {};
            $.each(frame.images, function (i, img) {
                if (frame.images[i].indexOf('left') >= 0) {
                    create_data.frame_images[handle]['left'] = img;
                } else if (frame.images[i].indexOf('center') >= 0) {
                    create_data.frame_images[handle]['center'] = img;
                } else if (frame.images[i].indexOf('right') >= 0) {
                    create_data.frame_images[handle]['right'] = img;
                } else if (frame.images[i].indexOf('corner') >= 0) {
                    create_data.frame_images[handle]['corner'] = img;
                }
            });
        });

        /*============================================================================
          #Functions
            - preload_images(preload_container, theme)
            - change_letter_image(position, letter, variant_id, custom_image)
            - resize_frame(input_data)
            - update_process_bar(target_step)
            - change_steps(target_step
            - hide_label(input)
            - change_theme(target_theme, custom_class)

        ==============================================================================*/


        /*================ preload_images(preload_container, theme) ================*/
        let preload_images = function (preload_container = modal.content, theme = 'all', limit = 0) {
            $.each(window.products, function (i, v) {
                let product = this;
                $.each(this.variants, function (i, v) {
                    let variant = this;
                    let v_img = '<img src="' + variant.featured_image.src + '" alt="' + product.title + '" ' +
                      'class="preload-image" ' +
                      'data-variant-id="' + variant.id + '" ' +
                      'data-variant-sku="' + variant.sku + '" ' +
                      'data-letter-id="' + product.handle.replace('letter-', '') + '" ' +
                      'data-theme-id="' + variant.option1 + '" ' +
                      'data-selection-type="preload" ' +
                      'crossorigin="anonymous" >';
                    if (theme === 'all') {
                        preload_container.append(v_img);
                        if (limit !== 0 && i >= limit - 1) {
                            return false;
                        }
                    } else if (variant.option1 === theme) {
                        preload_container.append(v_img);
                        if (limit !== 0 && i >= limit - 1) {
                            return false;
                        }
                    }
                });
            });
        };

        /*================ preload_frame_images(preload_container, frames) ================*/
        let preload_frame_images = function (preload_container, frames) {
            $.each(frames, function (k1, v1) {
                $.each(frames[k1], function (k2, v2) {
                    let frame_img = '<img src="' + v2 + '" class="preload-frame visually-hidden" alt="' + k1 + '" crossorigin="anonymous">';
                    preload_container.append(frame_img);
                });
            });
        };

        /*================ preload_custom_images(preload_container, image_file) ================*/
        let preload_custom_image = function (variant_id, image_file) {

            if (!(variant_id.toString().indexOf('||') >= 0)) {
                variant_id = variant_id + "||" + new Date().getTime();
            }

            let v_img = '<img src="' + image_file + '" ' +
              'class="preload-image" ' +
              'data-variant-id="' + variant_id + '" ' +
              'data-variant-sku="custom_image" ' +
              'data-letter-id="custom" ' +
              'data-theme-id="all" ' +
              'data-custom-id="image_file" ' +
              'data-selection-type="preload" ' +
              'crossorigin="anonymous" >';
            modal.content.prepend(v_img);
            add_images_to_modal();
        };

        /*================ change_letter_image(position, letter, variant_id, custom_image) ================*/
        let change_letter_image = function (position, letter = false, theme_data, variant_id = false) {

            let image_1 = '';
            let image_2 = '';
            let image_3 = '';
            let image_4 = '';

            switch (letter) {
                case '*':
                    letter = 'symbol-star';
                    break;
                case '&':
                    letter = 'symbol-ampersand';
                    break;
                case '#':
                    letter = 'symbol-hash';
                    break;
                case '!':
                    letter = 'symbol-exclaim';
                    break;
                case '-':
                    letter = 'symbol-dash';
                    break;
                case '@':
                    letter = 'symbol-heart';
                    break;
                case ' ':
                    letter = 'whitespace';
                    break;
            }

            if (variant_id) {
                image_1 = $('#create__modal .preload-image[data-variant-id="' + variant_id + '"]').clone(false).attr('data-selection-type', 'selected');
                image_2 = $('#create__modal .preload-image[data-variant-id="' + variant_id + '"]').clone(false).attr('data-selection-type', 'selected');
                image_3 = $('#create__modal .preload-image[data-variant-id="' + variant_id + '"]').clone(false).attr('data-selection-type', 'selected');
                image_4 = $('#create__modal .preload-image[data-variant-id="' + variant_id + '"]').clone(false).attr('data-selection-type', 'selected');
            } else if (letter) {
                image_1 = $('#create__modal .preload-image[data-letter-id="' + letter + '"][data-theme-id="' + theme_data + '"]').clone(false).attr('data-selection-type', 'auto');
                image_2 = $('#create__modal .preload-image[data-letter-id="' + letter + '"][data-theme-id="' + theme_data + '"]').clone(false).attr('data-selection-type', 'auto');
                image_3 = $('#create__modal .preload-image[data-letter-id="' + letter + '"][data-theme-id="' + theme_data + '"]').clone(false).attr('data-selection-type', 'auto');
                image_4 = $('#create__modal .preload-image[data-letter-id="' + letter + '"][data-theme-id="' + theme_data + '"]').clone(false).attr('data-selection-type', 'auto');
            }

            frame.image_array_1.eq(position).empty().append(image_1[0]);
            frame.image_array_2.eq(position).empty().append(image_2[0]);
            frame.image_array_3.eq(position).empty().append(image_3[0]);
            frame.image_array_4.eq(position).empty().append(image_4[0]);
        };

        /*================ update_frame_images(input_data, theme_data, custom_image)  ================*/
        let update_frame_images = function (input_data, theme_data = create_data.theme) {
            /* Remove images at positions larger than input */
            for (let i = input_data.length; i < 9; i++) {
                change_letter_image(i);
            }

            /* Add images if the input changed */
            for (let pos = 0; pos < 9; pos++) {
                let img = frame.image_array_1.eq(pos).children();
                let variant_id = false;

                if (input_data[pos] !== create_data.previous_input_array[pos]) {
                    if (pos !== input_data.length - 1) {
                        change_letter_image(pos, input_data[pos], theme_data, variant_id);
                    } else {
                        if (onTimeout[pos]) {
                            return true;
                        } else {
                            onTimeout[pos] = true;
                            setTimeout(function () {
                                change_letter_image(pos, input_data[pos], theme_data);
                                onTimeout[pos] = false;
                            }, 600);
                        }
                    }
                } else {
                    switch (img.attr('data-selection-type')) {
                        case 'auto':
                            variant_id = false;
                            break;
                        case 'selected':
                            variant_id = img.attr('data-variant-id');
                            break;
                    }
                    change_letter_image(pos, input_data[pos], theme_data, variant_id);
                }
            }
        };

        /*================ resize_frame(length, spacing = 0) ================*/
        let resize_frame = function (length, spacing = 0) {
            if (length >= 9) {
                spacing = 0;
            }
            frame.container.attr('data-frame-size', (length + spacing));
        };

        /*================ update_process_bar(target_step) ================*/
        let update_process_bar = function (target_step) {
            if (target_step === 1 || target_step > 1 && create_data.input_array.length >= 3) {
                create_navigation.process_steps.removeClass('process__item--active');
                $(create_navigation.process_steps[target_step - 1]).addClass('process__item--active');

                if (target_step === 3) {
                    frame.image_array_2.eq(0).children().addClass('tada animated');
                }
            }
        };

        /*================ change_steps(target_step) ================*/
        let change_steps = function (target_step) {
            if (target_step === 1 || target_step > 1 && create_data.input_array.length >= 3) {
                create_navigation.step_1.attr('style', 'margin-left: ' + -(target_step - 1) * 100 + 'vw');
            }
            if (target_step > 1 && create_data.input_array.length >= 3) {
                $('.shopify-section:not(.create-section):not(.header-section)').attr('style', 'display:none');
                $('.announcement-bar').attr('style', 'height: 0');
                $('.shopify-section.header-section').attr('style', 'opacity: 0.4; pointer-events: none;');
                $('body').attr('style', 'overflow-y: scroll');
            } else {
                $('.shopify-section:not(.create-section)').attr('style', '');
                $('.announcement-bar').attr('style', '');
                $('.shopify-section.header-section').attr('style', '');
                $('body').attr('style','');
            }
        };

        /*================ update_tabindex(2) ================*/
        let update_tabindex = function (target_step) {
            $('.create__step-' + target_step).focus();
            $('.create__slider [tabindex]').attr('tabindex', '-1');
            $('.create__step-' + target_step + ' [tabindex]').attr('tabindex', '0');
            $.each($('button.frame__letter[tabindex]'), function (i, letter_container) {
                if (letter_container.innerHTML.length === 0) {
                    $(letter_container).attr('tabindex', '-1');
                }
            });
        };

        /*================ hide_label(input_length) ================*/
        let hide_label = function (input_length) {
            if (input_length > 0) {
                frame.label.attr('style', 'opacity: 0;');
            } else {
                frame.label.attr('style', '');
            }
        };

        /*================ show_reset_button(input_length) ================*/
        let show_reset_button = function (input_length) {
            if (input_length > 0) {
                create_navigation.reset_button_1.removeClass('button--hidden').attr('tabindex', '0');
            } else {
                create_navigation.reset_button_1.addClass('button--hidden').attr('tabindex', '-1');
            }
        };

        /*================ change_theme(target_theme) ================*/
        let change_theme = function (target_theme, custom_class = 'theme__selected') {
            theme.item_array.removeClass(custom_class);
            $(target_theme).addClass(custom_class);
        };

        /*================ collect_input_cart_data(input) ================*/
        let collect_input_cart_data = function (input_array = create_data.input_array, variant_id = false, theme_data = create_data.theme, frame_data = create_data.frame, artwork_image_src = create_data.artwork_image_src) {
            create_data.input_array = input_array;
            create_data.input_word = input_array.join('');
            create_data.theme = theme_data;
            create_data.modal.theme_array = [theme_data];
            create_data.frame = frame_data;
            create_data.artwork_image_src = artwork_image_src;
            create_data.time_id = [new Date().getTime()];
            $.each(product_frames, function (i1, v2) {
                if (product_frames[i1].handle === frame_data) {
                    $.each(product_frames[i1].variants, function (i2, v2) {
                        if (parseInt(product_frames[i1].variants[i2].option1) === create_data.input_array.length) {
                            create_data.frame_variant_details = product_frames[i1].variants[i2];
                        }
                    });
                }
            });

            $.each(input_array, function (i, v) {
                create_data.input[i] = {
                    position: i + 1,
                    letter: v
                };
                if (variant_id[0] === i) {
                    create_data.input[i]['variant_id'] = variant_id[1];
                    create_data.input[i]['sku'] = $('.preload-image[data-variant-id="' + variant_id[1] + '"]').attr('data-variant-sku');
                    create_data.input[i]['custom_image'] = $('.frame__letter[data-letter-position="' + i + '"] .preload-image[data-custom-id="image_file"]').attr('src') || '';
                } else {
                    create_data.input[i]['variant_id'] = frame.image_array_1.eq(i).children().attr('data-variant-id');
                    create_data.input[i]['sku'] = frame.image_array_1.eq(i).children().attr('data-variant-sku');
                    create_data.input[i]['custom_image'] = $('.frame__letter[data-letter-position="' + i + '"] .preload-image[data-custom-id="image_file"]').attr('src') || '';
                    setTimeout(function () {
                        create_data.input[i]['variant_id'] = frame.image_array_1.eq(i).children().attr('data-variant-id');
                        create_data.input[i]['sku'] = frame.image_array_1.eq(i).children().attr('data-variant-sku');
                        create_data.input[i]['custom_image'] = $('.frame__letter[data-letter-position="' + i + '"] .preload-image[data-custom-id="image_file"]').attr('src') || '';
                    }, 650);
                }
            });

            for (let i = input_array.length; i < 9; i++) {
                create_data.input[i] = {};
            }
            create_data.gift_wrap = final_artwork.giftwrap_input.prop('checked') || false;
            create_data.gift_message = final_artwork.gift_message_input.val() || '';

            create_data.sharing_url = 'https://alphabetpix.myshopify.com/?frame=' + create_data.frame + '&word=' + create_data.input_array.join('');
            $.each(create_data.input_array, function (i) {
                if (create_data.input[i].custom_image !== '') {
                    create_data.sharing_url += '&pos-' + i + '=' + create_data.input[i].variant_id + '||||' + encodeURIComponent(create_data.input[i].custom_image);
                } else {
                    create_data.sharing_url += '&pos-' + i + '=' + create_data.input[i].variant_id;
                }
            });

            update_sharing_links();

            window.create_data = create_data;
            window.sessionStorage.create_data = JSON.stringify(create_data);
            update_cart_form(create_data);
            create_data.previous_input_array = create_data.input_array;
        };

        /*================Update_sharing_links(create_data) ================*/
        let update_sharing_links = function () {
            create_data.facebook_sharing_url = '//www.facebook.com/sharer.php?u=' + create_data.sharing_url;
            create_data.twitter_sharing_url = '//twitter.com/share?text=' + window.page_description + '&amp;url=' + create_data.sharing_url;
            create_data.pinterest_sharing_url = '//pinterest.com/pin/create/button/?url=' + create_data.sharing_url + '&amp;media=' + create_data.artwork_image_url + '&amp;description=' + window.page_description;

            final_artwork.sharing_link.attr('href', create_data.sharing_url).html(create_data.sharing_url);
            facebook_link.attr('href', create_data.facebook_sharing_url);
            twitter_link.attr('href', create_data.twitter_sharing_url);
            pinterest_link.attr('href', create_data.pinterest_sharing_url);
        };

        /*================ add_theme_image_to_modal(theme_data) ================*/
        let add_images_to_modal = function (position = create_data.modal.position, letter = create_data.modal.current_letter, theme_array = create_data.modal.theme_array) {
            create_data.modal.current_letter = letter;
            create_data.modal.position = position;
            /*default back to invisible*/
            modal.checkbox_array.prop('checked', false);
            $('.preload-image[data-selection-type="modal"]').attr('data-selection-type', 'preload').attr('data-letter-position', '');

            /*change images state for each theme*/
            $.each(theme_array, function (i, v) {
                if (theme_array[i] === 'all') {
                    $('.preload-image[data-letter-id="' + letter + '"][data-selection-type="preload"], .preload-image[data-custom-id][data-selection-type="preload"]').attr('data-selection-type', 'modal').attr('data-letter-position', position);
                } else {
                    $('.preload-image[data-letter-id="' + letter + '"][data-theme-id="' + theme_array[i] + '"][data-selection-type="preload"], .preload-image[data-custom-id][data-selection-type="preload"]').attr('data-selection-type', 'modal').attr('data-letter-position', position);
                }
                modal.checkbox_array.filter('[data-theme-id="' + theme_array[i] + '"]').prop('checked', true);
            });
            modal.active_image_array = $('.preload-image[data-selection-type="modal"]');
        };

        /*================ change_frame(frame_data) ================*/
        let change_frame = function (frame_handle) {
            $.each(frame.background, function (k, v) {
                frame.background[k].attr('src', create_data.frame_images[frame_handle][k]);
            });
        };

        /*================ create_final_artwork() ================*/
        let create_final_artwork = function () {
            if (create_data.input_array.length >= 3) {
                collect_input_cart_data(create_data.input_array, false, create_data.theme, create_data.frame);

                try {
                    domtoimage.toJpeg(fixed_size_frame[0], {quality: 0.4}).then(function (dataUrl) {
                        final_artwork.container.html('<img src="' + dataUrl + '" alt="Your Unique Artwork - ' + create_data.input_word + '">');
                        collect_input_cart_data(create_data.input_array, false, create_data.theme, create_data.frame, dataUrl);
                        postImageToFacebook("EAAFEyUKxbkMBADE2HTXZAZALfOpHnjM5ZAF08AUFPM34jF7wNedf2vKBzvHY8jFPyNZA7GmCZABBtTQ3M2KGBVrix0wP2FX2ulUCge6dGbjodMhGTZA7Xe7v40ABLxZC3pZAVmvikOFHDV6gCwMtRAASWVUvEc2bJxrwzvQPNHWnkEJS6SgKItB8", "Canvas to Facebook/Twitter", "image/png", dataURItoBlob(dataUrl), window.location.href);
                        download_link.attr('download', 'My personal frame - ' + create_data.input_array.join('')).attr('href', dataUrl).removeClass('visually-hidden');
                    });
                }
                catch (err) {
                    console.log('image not created');
                    console.log(err);
                }


                /* TODO Response Code Expires in 60 Days from 17.10.2017 - 17.12.2017 */
                /** https://graph.facebook.com/oauth/access_token?grant_type=fb_exchange_token&client_id=357106174750275&client_secret=02aa10066d5dd3b0f42276ed2b5842f5&fb_exchange_token=EAAFEyUKxbkMBAOEKZBVYGfzXJiidjq4usmfUyX4TNE6rplJcTJfM04EWrXcFBKFYZAxkl6U6Ds11muGl0bq3Dj1aYzM2Q7VQXQUy69LCOtH5ZAoorlpK5rWLzlJdYfVAfyOhR6VZC1kQpIeZCjJYTd1KsWXGtVerczZAwYVIgH8kc5fKNdEx28
                 *
                 * */

                /* FB.getLoginStatus(function (response) {
                   console.log(response);
                   if (response.status === "connected") {
                     postImageToFacebook(response.authResponse.accessToken, "Canvas to Facebook/Twitter", "image/png", blob, window.location.href);
                   } else if (response.status === "not_authorized") {
                     FB.login(function (response) {
                       postImageToFacebook(response.authResponse.accessToken, "Canvas to Facebook/Twitter", "image/png", blob, window.location.href);
                     }, {scope: "publish_actions"});
                   } else {
                     FB.login(function (response) {
                       postImageToFacebook(response.authResponse.accessToken, "Canvas to Facebook/Twitter", "image/png", blob, window.location.href);
                     }, {scope: "publish_actions"});
                   }
                 });*/
                final_artwork.word.html(create_data.input_array.join('').toUpperCase());
                final_artwork.format.html(create_data.resize_length + '-window');
                switch (create_data.resize_length) {
                    case 3:
                        final_artwork.size.html('13.5"h x 20"w');
                        break;
                    case 4:
                        final_artwork.size.html('13.5"h x 24.5"w');
                        break;
                    case 5:
                        final_artwork.size.html('13.5"h x 28.5"w');
                        break;
                    case 6:
                        final_artwork.size.html('13.5"h x 32.75"w');
                        break;
                    case 7:
                        final_artwork.size.html('13.5"h x 37"w');
                        break;
                    case 8:
                        final_artwork.size.html('13.5"h x 41.25"w');
                        break;
                    case 9:
                        final_artwork.size.html('13.5"h x 43.5"w');
                        break;
                }
                final_artwork.frame.html(create_data.frame);
          
                final_artwork.price.html('$' + create_data.frame_variant_details.price / 100);

            }
        };

        /*================ dataURItoBlob(dataURI) ================ Create_image_blob for facebook upload*/
        let dataURItoBlob = function (dataURI) {
            let byteString = atob(dataURI.split(',')[1]);
            let ab = new ArrayBuffer(byteString.length);
            let ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], {type: 'image/jpeg'});
        };

        /*================ postImageToFacebook(token, filename, mimeType, imageData, message) ================*/
        let postImageToFacebook = function (token, filename, mimeType, imageData, message) {
            let fd = new FormData();
            fd.append("access_token", token);
            fd.append("source", imageData);
            fd.append("no_story", true);

            // Upload image to facebook without story(post to feed)
            $.ajax({
                url: "https://graph.facebook.com/me/photos?access_token=" + token,
                type: "POST",
                data: fd,
                processData: false,
                contentType: false,
                cache: false,
                success: function (data) {
                    // Get image source url
                    FB.api(
                      "/" + data.id + "?fields=images&access_token=" + token,
                      function (response) {
                          if (response && !response.error) {

                              create_data.artwork_image_url = response.images[0].source;
                              /*================Create facebook sharing link ================*/
                              og.image.attr('content', create_data.artwork_image_url.replace('https://', 'http://'));
                              og.image_secure.attr('content', create_data.artwork_image_url);
                              create_data.sharing_url = create_data.sharing_url + '&image_url=' + encodeURIComponent(create_data.artwork_image_url);
                              update_sharing_links();
                              window.sessionStorage.create_data = JSON.stringify(create_data);
                              // Create facebook post using image
                              FB.api(
                                "/me/photos",
                                "POST",
                                {
                                    "picture": response.images[0].source,
                                    "link": window.location.href,
                                    "name": 'My Unique Artwork'
                                },
                                function (response) {
                                    if (response && !response.error) {
                                        /* handle the result */
                                    }
                                }
                              );
                          }
                      }
                    );
                },
                error: function (shr, status, data) {
                    console.log("error " + data + " Status " + shr.status);
                },
                complete: function (data) {
                    //console.log('Post to facebook Complete');
                }
            });
        };

        /*================   preload_artwork(url_values); ================*/
        let preload_artwork = function (url_values) {
            if (Object.keys(url_values).length > 1 && 'frame' in url_values && 'word' in url_values) {
                change_frame(url_values.frame);
                input_container.val(url_values.word);
                resize_frame(url_values.word.length);
                hide_label(url_values.word.length);
                show_reset_button(url_values.word.length);
                create_data.resize_length = url_values.word.length;
                for (let i = 0; i < url_values.word.length; i++) {
                    if (url_values['pos-' + i].indexOf('http') >= 0) {
                        let variant_id = url_values['pos-' + i].split('||||')[0];
                        let custom_image_url = url_values['pos-' + i].split('||||')[1];
                        console.log(variant_id);
                        preload_custom_image(variant_id, custom_image_url);
                        change_letter_image(i, url_values.word.charAt(i), url_values.frame, variant_id);
                        collect_input_cart_data(url_values.word.split(''), [i, url_values['pos-' + i]], url_values.frame, url_values.frame, url_values.image_url);
                    } else {
                        change_letter_image(i, url_values.word.charAt(i), url_values.frame, url_values['pos-' + i]);
                        collect_input_cart_data(url_values.word.split(''), [i, url_values['pos-' + i]], url_values.frame, url_values.frame, url_values.image_url);
                    }
                }
            }
        };
        /*================ update_cart_form(create_data) ================*/

        let update_cart_form = function (create_data) {
            cart_form.frame.attr('value', create_data.frame_variant_details.id).attr('disabled', 'disabled');
            cart_form.properties.attr('value', create_data.time_id[0]);
            for (let i = 0; i < 9; i++) {
                if ('variant_id' in create_data.input[i]) {
                    cart_form['letter_' + i].attr('value', create_data.input[i].variant_id).removeAttr('disabled');
                } else {
                    cart_form['letter_' + i].attr('value', '').attr('disabled', 'disabled');
                }
            }
        };

        /*================ cart_submit(create_data) ================*/
        let cart_submit = function (create_data) {
            let letter_sku_string = '';
            $.each(create_data.input_array, function (i) {
                create_data.input[i].sku = create_data.input[i].sku || '';
                letter_sku_string = letter_sku_string.concat((i + 1) + ': ' + create_data.input[i].sku.replace('horeline', '').replace('rontier', '').replace('lassic', '').replace('ntique', '').toUpperCase() + ' ');
            });

            let cart_data_array = [];
            create_data.properties = {
                'id': create_data.time_id,
                'word': create_data.input_array.join(''),
                'images': letter_sku_string,
                'letter_data': create_data.input
                /*'artwork': {image: create_data.artwork_image_src}*/
            };

            if (create_data.gift_wrap) {
                create_data.properties['gift_wrap'] = 'Yes';
            }
            if (create_data.gift_message !== '') {
                create_data.properties['gift_message'] = create_data.gift_message;
            }

            cart_data_array = [
                {
                    quantity: 1,
                    id: create_data.frame_variant_details.id,
                    image: create_data.artwork_image_src,
                    properties: create_data.properties
                }
            ];
            $.each(create_data.input_array, function (i) {
                if (create_data.input[i].custom_image !== '') {
                    cart_data_array.unshift({
                        quantity: 1,
                        id: create_data.input[i].variant_id.split('||')[0],
                        properties: {
                            'id': create_data.time_id,
                            'position': i + 1,
                            'custom_image': create_data.input[i].custom_image
                        }
                    });
                } else {
                    cart_data_array.unshift({
                        quantity: 1,
                        id: create_data.input[i].variant_id,
                        properties: {
                            'id': create_data.time_id,
                            'position': i + 1
                        }
                    });
                }
            });

            cart_data_array.push();
            addToCartMultiple(cart_data_array);
        };

        /*============================================================================
          # Events
            - input_container
                .on('input')
                .on('focus')
                .on('blur')
            - create_button_1
                .on('click')

           - theme
              .item_array
                .on('click')
           - frame
              .image_array_2
                  .on('click')
           - modal
              .checkbox_array
                  .on('click')
              .active_image_array
                  .on('click')
        ==============================================================================*/

        /*================ input_container.on('input') ================*/
        input_container.on('input change', function () {
            create_data.input_array = input_container.val().toLowerCase().split('');

            /* Resize frame once reached 3 letters, leaving space for 1 letter input */
            if (create_data.input_array.length > 2) {
                create_data.resize_length = create_data.input_array.length;
                resize_frame(create_data.resize_length, 1);
            } else {
                create_data.resize_length = 7;
                resize_frame(create_data.resize_length);
            }

            update_frame_images(create_data.input_array);
            hide_label(create_data.input_array.length);
            show_reset_button(create_data.input_array.length);
            collect_input_cart_data(create_data.input_array);
        });

        /*================ input_container.on('focus') ================*/
        input_container.on('focus', function () {
            resize_frame(create_data.resize_length, 1);
        });

        /*================ input_container.on('blur') ================*/
        input_container.on('blur', function () {
            resize_frame(create_data.resize_length);
        });

        /*================ Navigation.on('click') ================*/
        /*Step-1*/
        create_navigation.next_button_1.on('click', function () {
            change_steps(2);
            update_process_bar(2);
            update_tabindex(2);
        });
        create_navigation.reset_button_1.on('click', function () {
            input_container.val('').trigger('input');
        });

        /*Step-2*/
        create_navigation.prev_button_2.on('click', function () {
            change_steps(1);
            update_process_bar(1);
            update_tabindex(1);
        });
        create_navigation.next_button_2.on('click', function () {
            change_steps(3);
            update_process_bar(3);
            update_tabindex(3);
        });

        /*Step-3*/
        create_navigation.prev_button_3.on('click', function () {
            change_steps(2);
            update_process_bar(2);
            update_tabindex(2);
        });
        create_navigation.next_button_3.on('click', function () {
            change_steps(4);
            update_process_bar(4);
            update_tabindex(4);
            create_final_artwork();
        });

        /*Step-4*/
        create_navigation.prev_button_4.on('click', function () {
            change_steps(3);
            update_process_bar(3);
            update_tabindex(3);
        });

        create_navigation.next_button_4.on('click', function () {
            $(this).addClass('btn--loader-active').attr('style', 'color: transparent !important;');
            cart_submit(create_data);
        });

        /*================ process_steps.on('click') ================*/
        create_navigation.process_steps.on('click', function () {
            let target = parseInt($(this).attr('data-step-id'));
            change_steps(target);
            update_process_bar(target);
            if (target === 4) {
                create_final_artwork();
            }
        });

        /*================ theme.item_array.on('click') ================*/
        theme.item_array.on('click', function () {
            let theme_id = $(this).attr('data-theme-id');
            change_theme(this);
            update_frame_images(create_data.input_array, theme_id);
            collect_input_cart_data(create_data.input_array, false, theme_id, theme_id);
            change_frame(theme_id);
            theme.frame_change.removeClass('theme-change__item--active');
            $('.theme-change__item[data-theme-id="' + theme_id + '"]').addClass('theme-change__item--active');
        });

        /*================ theme.frame_change.on('click') ================*/
        theme.frame_change.on('click', function (e) {
            let theme_id = $(this).attr('data-theme-id');
            e.preventDefault();
            theme.frame_change.removeClass('theme-change__item--active');
            collect_input_cart_data(create_data.input_array, false, create_data.theme, theme_id);
            change_frame(theme_id);
            $(this).addClass('theme-change__item--active');
        });

        /*================ frame.image_array_2.on('click') ================*/
        frame.image_array_2.on('click', function (e) {
            e.preventDefault();
            add_images_to_modal($(this).attr('data-letter-position'), $(this).children().attr('data-letter-id'), [create_data.theme]);
            modal.container.modal('toggle');
        });

        /*================ modal.checkbox_array.on('click') ================*/
        modal.checkbox_array.on('click', function () {
            if ($(this).prop('checked') === true) {
                if ($(this).attr('data-theme-id') === 'all') {
                    create_data.modal.theme_array = ['antique', 'classic', 'shoreline', 'frontier', 'all'];
                } else {
                    create_data.modal.theme_array = create_data.modal.theme_array.concat($(this).attr('data-theme-id'));
                }
                add_images_to_modal(create_data.modal.position, create_data.modal.current_letter, create_data.modal.theme_array);
            } else if ($(this).prop('checked') === false) {
                if ($(this).attr('data-theme-id') === 'all') {
                    create_data.modal.theme_array = [create_data.theme];
                } else {
                    create_data.modal.theme_array.splice(create_data.modal.theme_array.indexOf($(this).attr('data-theme-id')), 1);
                }
                add_images_to_modal(create_data.modal.position, create_data.modal.current_letter, create_data.modal.theme_array);
            }
        });

        /*================ modal.active_image_array.on('click') ================*/
        modal.content.on('click', modal.active_image_array, function (e) {

            let img = $(e.target);
            let position = img.attr('data-letter-position');
            let theme_data = img.attr('data-theme-id');
            let letter = img.attr('data-letter-id');
            let variant_id = img.attr('data-variant-id');

            change_letter_image(position, letter, theme_data, variant_id);
            collect_input_cart_data(create_data.input_array, [position, variant_id]);

            modal.container.modal('toggle');
        });

        /*================final_artwork.giftwrap_input.on('change input') ================*/
        final_artwork.giftwrap_input.on('change input', function (e) {
            collect_input_cart_data();
        });

        /*================ ================*/
        final_artwork.gift_message_input.on('change input', function (e) {
            collect_input_cart_data();
        });

        /*============================================================================
          #Initialization
            - preload_images()

        ==============================================================================*/

        preload_images(modal.content, 'all', 0);
        preload_frame_images(modal.content, create_data.frame_images);
        window.create_data = create_data;
        window.sessionStorage.create_data = JSON.stringify(create_data);
        window.preload_custom_image = preload_custom_image;
        preload_artwork(window.url_values);
        change_theme($('.theme__item[data-theme-id="' + create_data.theme + '"]'));
    }

    Create.prototype = $.extend({}, Create.prototype, {

        onBlockSelect: function (evt) {
            /*this.$container.off(this.namespace);*/
            $('.create__step-1').attr('style', 'margin-left: ' + -(2 - 1) * 100 + 'vw');
            $('.theme__item').removeClass('theme__selected');
            $('.theme__item[data-block-id="' + evt.detail.blockId + '"]').addClass('theme__selected');
        },
        onBlockDeselect: function (evt) {
            /*this.$container.off(this.namespace);*/
            $('.create__step-1').attr('style', 'margin-left: ' + -(1 - 1) * 100 + 'vw');
        }

    });

    return Create;
})
();



/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.GridImages = (function () {

  /*var selectors = {
   addToCart: '[data-add-to-cart]',
   addToCartText: '[data-add-to-cart-text]',
   comparePrice: '[data-compare-price]',
   comparePriceText: '[data-compare-text]',
   originalSelectorId: '[data-product-select]',
   priceWrapper: '[data-price-wrapper]',
   productFeaturedImage: '[data-product-featured-image]',
   productJson: '[data-product-json]',
   productPrice: '[data-product-price]',
   productThumbs: '[data-product-single-thumbnail]',
   singleOptionSelector: '[data-single-option-selector]'
   };*/


  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function GridImages(container) {
    this.$container = $(container);
    this.settings = {};
    this.namespace = '.grid-images';

    var sectionId = this.$container.attr('data-section-id');
  }

  GridImages.prototype = $.extend({}, GridImages.prototype, {


    onBlockSelect: function (evt) {
      this.$container.off(this.namespace);

      var selectedBlock = $('[data-block-id="' + evt.detail.blockId + '"]');
      selectedBlock.css({
        'border': '3px solid red',
        'transform': 'scale(1.1)',
        'z-index': '9'
      });
    },

    onBlockDeselect: function (evt) {
      this.$container.off(this.namespace);

      var selectedBlock = $('[data-block-id="' + evt.detail.blockId + '"]');
      selectedBlock.css({
        'border': '',
        'transform': '',
        'z-index': ''
      });
    }

  });

  return GridImages;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Modules ================*/
$(document).ready(function () {
  // Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('[href="/#"]')
    .not('[href="/#0"]')
    .click(function (event) {
      // On-page links

      if (window.innerWidth < 930 && $(this).hasClass('navigation__link-anchor')) {
        $('button.site-header__navigation').click();


        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          var link = $(this);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            setTimeout(function(e) {
              $('html, body').animate({
                scrollTop: (target.offset().top - 200)
              }, 800, function () {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                /*$target.focus();*/
                if ($target.is(":focus")) { // Checking if the target was focused

                  /*link.addClass('active');*/
                  return false;
                } else {
                  $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                }
              });
            }, 200);
          }
        }

        if ($(this).attr('href').includes('create__slide')) {
          $('.create__block').removeClass('slideshow__slide--active');
          $($(this).attr('href').replace(/^\//, '')).addClass('slideshow__slide--active');
          $('.slideshow__button--active').removeClass('slideshow__button--active');
          $('#create__slide-button--' + $(this).attr('href').replace(/\D+/g, '')).addClass('slideshow__button--active');
        }
      } else {
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          var link = $(this);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: (target.offset().top - 200)
            }, 800, function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              /*$target.focus();*/
              if ($target.is(":focus")) { // Checking if the target was focused

                /*link.addClass('active');*/
                return false;
              } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            });
            /* RELOAD ANIMATIONS */
            new WOW().init({
              mobile: false      // trigger animations on mobile devices (default is true)
            });
          }
        }

        if ($(this).attr('href').includes('create__slide')) {
          $('.create__block').removeClass('slideshow__slide--active');
          $($(this).attr('href').replace(/^\//, '')).addClass('slideshow__slide--active');
          $('.slideshow__button--active').removeClass('slideshow__button--active');
          $('#create__slide-button--' + $(this).attr('href').replace(/\D+/g, '')).addClass('slideshow__button--active');
        }
      }
    });

  /*$('button.slideshow__button-label').on('click', function () {
    $('.create__block').removeClass('slideshow__slide--active');
  });*/


  $(window).scroll(function () {
    //if you hard code, then use console
    //.log to determine when you want the
    //nav bar to stick.
    /*console.log($(window).scrollTop());*/
    if ($(window).scrollTop() > 650) {
      $('.header').addClass('header--fixed');
    }
    if ($(window).scrollTop() < 650) {
      $('.header').removeClass('header--fixed');
    }

    return onScroll();
  });


  function onScroll(event) {
    var scrollPos = $(window).scrollTop();
    $('header a[href*="#"]')
    // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('[href="/#"]')
      .not('[href="/#0"]')
      .each(function (event) {
        // On-page links

        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          if (target[0]) {
            var link = $(this);
            if (target.offset().top - 200 <= scrollPos && target.offset().top + target.height() + 200 > scrollPos) {
              link.addClass("active");
            }
            else {
              link.removeClass("active");
            }
          }
        }
      });
  }
});







(function() {
    var MutationObserver, Util, WeakMap, getComputedStyle, getComputedStyleRX,
        bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
        indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

    Util = (function() {
        function Util() {}

        Util.prototype.extend = function(custom, defaults) {
            var key, value;
            for (key in defaults) {
                value = defaults[key];
                if (custom[key] == null) {
                    custom[key] = value;
                }
            }
            return custom;
        };

        Util.prototype.isMobile = function(agent) {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent);
        };

        Util.prototype.createEvent = function(event, bubble, cancel, detail) {
            var customEvent;
            if (bubble == null) {
                bubble = false;
            }
            if (cancel == null) {
                cancel = false;
            }
            if (detail == null) {
                detail = null;
            }
            if (document.createEvent != null) {
                customEvent = document.createEvent('CustomEvent');
                customEvent.initCustomEvent(event, bubble, cancel, detail);
            } else if (document.createEventObject != null) {
                customEvent = document.createEventObject();
                customEvent.eventType = event;
            } else {
                customEvent.eventName = event;
            }
            return customEvent;
        };

        Util.prototype.emitEvent = function(elem, event) {
            if (elem.dispatchEvent != null) {
                return elem.dispatchEvent(event);
            } else if (event in (elem != null)) {
                return elem[event]();
            } else if (("on" + event) in (elem != null)) {
                return elem["on" + event]();
            }
        };

        Util.prototype.addEvent = function(elem, event, fn) {
            if (elem.addEventListener != null) {
                return elem.addEventListener(event, fn, false);
            } else if (elem.attachEvent != null) {
                return elem.attachEvent("on" + event, fn);
            } else {
                return elem[event] = fn;
            }
        };

        Util.prototype.removeEvent = function(elem, event, fn) {
            if (elem.removeEventListener != null) {
                return elem.removeEventListener(event, fn, false);
            } else if (elem.detachEvent != null) {
                return elem.detachEvent("on" + event, fn);
            } else {
                return delete elem[event];
            }
        };

        Util.prototype.innerHeight = function() {
            if ('innerHeight' in window) {
                return window.innerHeight;
            } else {
                return document.documentElement.clientHeight;
            }
        };

        return Util;

    })();

    WeakMap = this.WeakMap || this.MozWeakMap || (WeakMap = (function() {
            function WeakMap() {
                this.keys = [];
                this.values = [];
            }

            WeakMap.prototype.get = function(key) {
                var i, item, j, len, ref;
                ref = this.keys;
                for (i = j = 0, len = ref.length; j < len; i = ++j) {
                    item = ref[i];
                    if (item === key) {
                        return this.values[i];
                    }
                }
            };

            WeakMap.prototype.set = function(key, value) {
                var i, item, j, len, ref;
                ref = this.keys;
                for (i = j = 0, len = ref.length; j < len; i = ++j) {
                    item = ref[i];
                    if (item === key) {
                        this.values[i] = value;
                        return;
                    }
                }
                this.keys.push(key);
                return this.values.push(value);
            };

            return WeakMap;

        })());

    MutationObserver = this.MutationObserver || this.WebkitMutationObserver || this.MozMutationObserver || (MutationObserver = (function() {
            function MutationObserver() {
                if (typeof console !== "undefined" && console !== null) {
                    console.warn('MutationObserver is not supported by your browser.');
                }
                if (typeof console !== "undefined" && console !== null) {
                    console.warn('WOW.js cannot detect dom mutations, please call .sync() after loading new content.');
                }
            }

            MutationObserver.notSupported = true;

            MutationObserver.prototype.observe = function() {};

            return MutationObserver;

        })());

    getComputedStyle = this.getComputedStyle || function(el, pseudo) {
            this.getPropertyValue = function(prop) {
                var ref;
                if (prop === 'float') {
                    prop = 'styleFloat';
                }
                if (getComputedStyleRX.test(prop)) {
                    prop.replace(getComputedStyleRX, function(_, _char) {
                        return _char.toUpperCase();
                    });
                }
                return ((ref = el.currentStyle) != null ? ref[prop] : void 0) || null;
            };
            return this;
        };

    getComputedStyleRX = /(\-([a-z]){1})/g;

    this.WOW = (function() {
        WOW.prototype.defaults = {
            boxClass: 'scroll',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true,
            callback: null,
            scrollContainer: null
        };

        function WOW(options) {
            if (options == null) {
                options = {};
            }
            this.scrollCallback = bind(this.scrollCallback, this);
            this.scrollHandler = bind(this.scrollHandler, this);
            this.resetAnimation = bind(this.resetAnimation, this);
            this.start = bind(this.start, this);
            this.scrolled = true;
            this.config = this.util().extend(options, this.defaults);
            if (options.scrollContainer != null) {
                this.config.scrollContainer = document.querySelector(options.scrollContainer);
            }
            this.animationNameCache = new WeakMap();
            this.wowEvent = this.util().createEvent(this.config.boxClass);
        }

        WOW.prototype.init = function() {
            var ref;
            this.element = window.document.documentElement;
            if ((ref = document.readyState) === "interactive" || ref === "complete") {
                this.start();
            } else {
                this.util().addEvent(document, 'DOMContentLoaded', this.start);
            }
            return this.finished = [];
        };

        WOW.prototype.start = function() {
            var box, j, len, ref;
            this.stopped = false;
            this.boxes = (function() {
                var j, len, ref, results;
                ref = this.element.querySelectorAll("." + this.config.boxClass);
                results = [];
                for (j = 0, len = ref.length; j < len; j++) {
                    box = ref[j];
                    results.push(box);
                }
                return results;
            }).call(this);
            this.all = (function() {
                var j, len, ref, results;
                ref = this.boxes;
                results = [];
                for (j = 0, len = ref.length; j < len; j++) {
                    box = ref[j];
                    results.push(box);
                }
                return results;
            }).call(this);
            if (this.boxes.length) {
                if (this.disabled()) {
                    this.resetStyle();
                } else {
                    ref = this.boxes;
                    for (j = 0, len = ref.length; j < len; j++) {
                        box = ref[j];
                        this.applyStyle(box, true);
                    }
                }
            }
            if (!this.disabled()) {
                this.util().addEvent(this.config.scrollContainer || window, 'scroll', this.scrollHandler);
                this.util().addEvent(window, 'resize', this.scrollHandler);
                this.interval = setInterval(this.scrollCallback, 50);
            }
            if (this.config.live) {
                return new MutationObserver((function(_this) {
                    return function(records) {
                        var k, len1, node, record, results;
                        results = [];
                        for (k = 0, len1 = records.length; k < len1; k++) {
                            record = records[k];
                            results.push((function() {
                                var l, len2, ref1, results1;
                                ref1 = record.addedNodes || [];
                                results1 = [];
                                for (l = 0, len2 = ref1.length; l < len2; l++) {
                                    node = ref1[l];
                                    results1.push(this.doSync(node));
                                }
                                return results1;
                            }).call(_this));
                        }
                        return results;
                    };
                })(this)).observe(document.body, {
                    childList: true,
                    subtree: true
                });
            }
        };

        WOW.prototype.stop = function() {
            this.stopped = true;
            this.util().removeEvent(this.config.scrollContainer || window, 'scroll', this.scrollHandler);
            this.util().removeEvent(window, 'resize', this.scrollHandler);
            if (this.interval != null) {
                return clearInterval(this.interval);
            }
        };

        WOW.prototype.sync = function(element) {
            if (MutationObserver.notSupported) {
                return this.doSync(this.element);
            }
        };

        WOW.prototype.doSync = function(element) {
            var box, j, len, ref, results;
            if (element == null) {
                element = this.element;
            }
            if (element.nodeType !== 1) {
                return;
            }
            element = element.parentNode || element;
            ref = element.querySelectorAll("." + this.config.boxClass);
            results = [];
            for (j = 0, len = ref.length; j < len; j++) {
                box = ref[j];
                if (indexOf.call(this.all, box) < 0) {
                    this.boxes.push(box);
                    this.all.push(box);
                    if (this.stopped || this.disabled()) {
                        this.resetStyle();
                    } else {
                        this.applyStyle(box, true);
                    }
                    results.push(this.scrolled = true);
                } else {
                    results.push(void 0);
                }
            }
            return results;
        };

        WOW.prototype.show = function(box) {
            this.applyStyle(box);
            box.className = box.className + " " + this.config.animateClass;
            if (this.config.callback != null) {
                this.config.callback(box);
            }
            this.util().emitEvent(box, this.wowEvent);
            this.util().addEvent(box, 'animationend', this.resetAnimation);
            this.util().addEvent(box, 'oanimationend', this.resetAnimation);
            this.util().addEvent(box, 'webkitAnimationEnd', this.resetAnimation);
            this.util().addEvent(box, 'MSAnimationEnd', this.resetAnimation);
            return box;
        };

        WOW.prototype.applyStyle = function(box, hidden) {
            var delay, duration, iteration, repeat;
            duration = box.getAttribute('data-scroll-duration');
            delay = box.getAttribute('data-scroll-delay') || "0.3s";
            iteration = box.getAttribute('data-scroll-iteration');
            return this.animate((function(_this) {
                return function() {
                    return _this.customStyle(box, hidden, duration, delay, iteration, repeat);
                };
            })(this));
        };

        WOW.prototype.animate = (function() {
            if ('requestAnimationFrame' in window) {
                return function(callback) {
                    return window.requestAnimationFrame(callback);
                };
            } else {
                return function(callback) {
                    return callback();
                };
            }
        })();

        WOW.prototype.resetStyle = function() {
            var box, j, len, ref, results;
            ref = this.boxes;
            results = [];
            for (j = 0, len = ref.length; j < len; j++) {
                box = ref[j];
                results.push(box.style.visibility = 'visible');
            }
            return results;
        };

        WOW.prototype.resetAnimation = function(event) {
            var target;
            if (event.type.toLowerCase().indexOf('animationend') >= 0) {
                target = event.target || event.srcElement;
                return target.className = target.className.replace(this.config.animateClass, '').trim();
            }
        };

        WOW.prototype.customStyle = function(box, hidden, duration, delay, iteration, repeat) {
            if (hidden) {
                this.cacheAnimationName(box);
            }
            box.style.visibility = hidden ? 'hidden' : 'visible';
            if (duration) {
                this.vendorSet(box.style, {
                    animationDuration: duration
                });
            }
            if (delay) {
                this.vendorSet(box.style, {
                    animationDelay: delay
                });
            }
            if (iteration) {
                this.vendorSet(box.style, {
                    animationIterationCount: iteration
                });
            }

            this.vendorSet(box.style, {
                animationName: hidden ? 'none' : this.cachedAnimationName(box)
            });
            return box;
        };

        WOW.prototype.vendors = ["moz", "webkit"];

        WOW.prototype.vendorSet = function(elem, properties) {
            var name, results, value, vendor;
            results = [];
            for (name in properties) {
                value = properties[name];
                elem["" + name] = value;
                results.push((function() {
                    var j, len, ref, results1;
                    ref = this.vendors;
                    results1 = [];
                    for (j = 0, len = ref.length; j < len; j++) {
                        vendor = ref[j];
                        results1.push(elem["" + vendor + (name.charAt(0).toUpperCase()) + (name.substr(1))] = value);
                    }
                    return results1;
                }).call(this));
            }
            return results;
        };

        WOW.prototype.vendorCSS = function(elem, property) {
            var j, len, ref, result, style, vendor;
            style = getComputedStyle(elem);
            result = style.getPropertyCSSValue(property);
            ref = this.vendors;
            for (j = 0, len = ref.length; j < len; j++) {
                vendor = ref[j];
                result = result || style.getPropertyCSSValue("-" + vendor + "-" + property);
            }
            return result;
        };

        WOW.prototype.animationName = function(box) {
            var animationName, error;
            try {
                animationName = this.vendorCSS(box, 'animation-name').cssText;
            } catch (error) {
                animationName = getComputedStyle(box).getPropertyValue('animation-name');
            }
            if (animationName === 'none') {
                return '';
            } else {
                return animationName;
            }
        };

        WOW.prototype.cacheAnimationName = function(box) {
            return this.animationNameCache.set(box, this.animationName(box));
        };

        WOW.prototype.cachedAnimationName = function(box) {
            return this.animationNameCache.get(box);
        };

        WOW.prototype.scrollHandler = function() {
            return this.scrolled = true;
        };

        WOW.prototype.scrollCallback = function() {
            var box;
            if (this.scrolled) {
                this.scrolled = false;
                this.boxes = (function() {
                    var j, len, ref, results;
                    ref = this.boxes;
                    results = [];
                    for (j = 0, len = ref.length; j < len; j++) {
                        box = ref[j];
                        if (!(box)) {
                            continue;
                        }
                        if (this.isVisible(box)) {
                            this.show(box);
                            continue;
                        }
                        results.push(box);
                    }
                    return results;
                }).call(this);
                if (!(this.boxes.length || this.config.live)) {
                    return this.stop();
                }
            }
        };

        WOW.prototype.addBox = function(element){
            this.boxes.push(element);
        };

        WOW.prototype.offsetTop = function(element) {
            var top;
            while (element.offsetTop === void 0) {
                element = element.parentNode;
            }
            top = element.offsetTop;
            while (element = element.offsetParent) {
                top += element.offsetTop;
            }
            return top;
        };

        WOW.prototype.isVisible = function(box) {
            var bottom, offset, top, viewBottom, viewTop;
            offset = box.getAttribute('data-scroll-offset') || this.config.offset;
            viewTop = (this.config.scrollContainer && this.config.scrollContainer.scrollTop) || window.pageYOffset;
            viewBottom = viewTop + Math.min(this.element.clientHeight, this.util().innerHeight()) - offset;
            top = this.offsetTop(box);
            bottom = top + box.clientHeight;
            return top <= viewBottom && bottom >= viewTop;
        };

        WOW.prototype.util = function() {
            return this._util != null ? this._util : this._util = new Util();
        };

        WOW.prototype.disabled = function() {
            return !this.config.mobile && this.util().isMobile(navigator.userAgent);
        };

        return WOW;

    })();

}).call(this);

new WOW().init({
  mobile: false      // trigger animations on mobile devices (default is true)
});

$(function() {
  if (window.innerWidth < 640) {
    $('.scroll').removeClass('scroll');
    console.log('test');
  }
});


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('create-section', theme.Create);
  sections.register('slider-section', theme.Slider);
  sections.register('testimonials-section', theme.TestimonialSlider);
  sections.register('grid-images-section', theme.GridImages);
  sections.register('theme-collection-section');
  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
